import { typedKeys } from './object.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function transformKeysNested(object, transform) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_ignoreKeys = options.ignoreKeys, ignoreKeys = _options_ignoreKeys === void 0 ? [] : _options_ignoreKeys, _options_ignoreKeysUnder = options.ignoreKeysUnder, ignoreKeysUnder = _options_ignoreKeysUnder === void 0 ? [] : _options_ignoreKeysUnder, _options_ignoreNestedKeysUnder = options.ignoreNestedKeysUnder, ignoreNestedKeysUnder = _options_ignoreNestedKeysUnder === void 0 ? [] : _options_ignoreNestedKeysUnder;
    return typeof object === "object" ? typedKeys(object).reduce(function(result, key) {
        var shouldNotTransform = ignoreKeys.includes(key);
        var shouldIgnoreNestedKeysUnder = ignoreNestedKeysUnder.includes(key);
        var value = object[key];
        if (Array.isArray(value)) {
            var arrayValue = value;
            return _object_spread_props(_object_spread({}, result), _define_property({}, shouldNotTransform ? key : transform(key), shouldIgnoreNestedKeysUnder ? arrayValue : arrayValue.map(function(el) {
                return transformKeysNested(el, transform, {
                    ignoreKeys: ignoreKeys,
                    ignoreKeysUnder: ignoreKeysUnder,
                    ignoreNestedKeysUnder: ignoreNestedKeysUnder
                });
            })));
        } else if (typeof value === "object" && value != null) {
            var objectValue = value;
            var shouldIgnoreKeysUnder = ignoreKeysUnder.includes(key);
            var mergedIgnoredKeys = ignoreKeys.concat(shouldIgnoreKeysUnder ? typedKeys(objectValue) : []);
            return _object_spread_props(_object_spread({}, result), _define_property({}, shouldNotTransform ? key : transform(key), shouldIgnoreNestedKeysUnder ? objectValue : transformKeysNested(objectValue, transform, {
                ignoreKeys: mergedIgnoredKeys,
                ignoreKeysUnder: ignoreKeysUnder,
                ignoreNestedKeysUnder: ignoreNestedKeysUnder
            })));
        }
        return _object_spread_props(_object_spread({}, result), _define_property({}, shouldNotTransform ? key : transform(key), value));
    }, {}) : object;
}
function transformValuesNested(element, transform) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, currentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var _options_ignoreKeys = options.ignoreKeys, ignoreKeys = _options_ignoreKeys === void 0 ? [] : _options_ignoreKeys;
    if (Array.isArray(element)) {
        return element.map(function(el, index) {
            return transformValuesNested(el, transform, {
                ignoreKeys: ignoreKeys
            }, "".concat(currentPath, "[").concat(index, "]"));
        });
    } else if (typeof element === "object") {
        return Object.entries(element).reduce(function(result, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            var shouldNotTransform = ignoreKeys.includes(key);
            if (Array.isArray(value)) {
                var arrayValue = value;
                return _object_spread_props(_object_spread({}, result), _define_property({}, key, shouldNotTransform ? arrayValue : arrayValue.map(function(el, index) {
                    return transformValuesNested(el, transform, {
                        ignoreKeys: ignoreKeys
                    }, currentPath === "" ? "".concat(key, "[").concat(index, "]") : "".concat(currentPath, ".").concat(key, "[").concat(index, "]"));
                })));
            } else if (value != null && typeof value === "object") {
                var objectValue = value;
                return _object_spread_props(_object_spread({}, result), _define_property({}, key, shouldNotTransform ? objectValue : transformValuesNested(objectValue, transform, {
                    ignoreKeys: ignoreKeys
                }, currentPath === "" ? key : "".concat(currentPath, ".").concat(key))));
            } else {
                var simpleValue = value;
                return _object_spread_props(_object_spread({}, result), _define_property({}, key, shouldNotTransform ? value : transform(simpleValue, currentPath === "" ? key : "".concat(currentPath, ".").concat(key))));
            }
        }, {});
    }
    return transform(element, currentPath);
}
function transformValues(object, transform) {
    return Object.fromEntries(Object.entries(object).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            transform(value)
        ];
    }));
}
function removeNullishValuesRecursively(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = _sliced_to_array(param, 2); _param[0]; var v = _param[1];
        return v != null;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
        return [
            k,
            v === Object(v) && !Array.isArray(v) ? removeNullishValuesRecursively(v) : v
        ];
    }));
}

export { removeNullishValuesRecursively, transformKeysNested, transformValues, transformValuesNested };
